export default "__VITE_ASSET__BmJbW7Qz__"